var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#012169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 16M24 0L0 16",
    stroke: "#FFFFFF",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 16M24 0L0 16",
    stroke: "#C8102E",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V16M0 8H24",
    stroke: "#FFFFFF",
    strokeWidth: 4.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V16M0 8H24",
    stroke: "#C8102E",
    strokeWidth: 2.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.bdb0030dc53ec19f6643ac34aa282d43.svg";
export { ForwardRef as ReactComponent };